namespace $ {

	type Bottom_quick_access_item = {
		id: string,
		fullscreen?: boolean,
	}

	class $shm_hitalama_profile_home extends $giper_baza_flex_subj.with({
		Hitalama_profile: $giper_baza_atom_link.to( ()=> $shm_hitalama_profile ),
	}) {
		
	}

	class $shm_hitalama_profile_jsons extends $giper_baza_atom_link_to(
		()=> $giper_baza_dict_to( $giper_baza_atom_link_to( ()=> $giper_baza_atom_dict ) )
	) {

	}

	export class $shm_hitalama_profile extends $giper_baza_entity.with({

		Secrets: $giper_baza_atom_link.to( ()=> $giper_baza_atom_dict ),

		Tokens: $giper_baza_list_link.to( ()=> $shm_hitalama_vk_token ),
		Groups_lists: $giper_baza_list_link.to( ()=> $shm_hitalama_vk_list ),

		Projects: $giper_baza_list_link.to( ()=> $shm_hitalama_project ),
		Maps: $giper_baza_atom_link.to( ()=> $giper_baza_list_link.to( ()=> $shm_hitalama_map ) ),

		Maps_removed: $giper_baza_atom_link.to( ()=> $giper_baza_list_link.to( ()=> $shm_hitalama_map ) ),
		Templates_js: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Templates_tsx: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Templates_sql: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Templates_commands: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Overlayed_map: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Overlayed_map_enabled: $giper_baza_atom_bool,

		Login: $giper_baza_atom_text,
		Pass_key: $giper_baza_atom_text,
		Version: $giper_baza_atom_real,

		Extension_current: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ),

		Maps_sort_order: $giper_baza_atom_text,
		Maps_sort_by: $giper_baza_atom_text,

		Agent_chat_room: $giper_baza_atom_link.to( ()=> $shm_hitalama_chat_room ),
		Agent_chat_options: $giper_baza_atom_link.to( ()=> $shm_hitalama_chat_room_personal ),

		Used_tags: $giper_baza_list_str,

		Bottom_quick_access_items: $giper_baza_atom_list,
		Bottom_quick_access_ordered: $giper_baza_list_str,

		Jsons: $shm_hitalama_profile_jsons,

	}){

		static maps_list_repair_cache = new Map< string, any >

		static home() {
			return this.$.$giper_baza_glob!.home().cast($shm_hitalama_profile_home)
		}

		@ $mol_mem
		static current() {
			const profile = $shm_hitalama_profile.home().Hitalama_profile()?.remote()
			if( !profile?.Login()?.val() ) return null
			if( profile.Version()?.val() === null ) return null
			if( profile ) $shm_hitalama_profile_migration.migrate( profile )
			return profile
		}

		@ $mol_action
		password( password: string ) {
			const auth = this.$.$giper_baza_auth.current()
			const pass_key = $mol_wire_sync( this.$.$shm_hitalama_profile_key ).export(
				auth.toString() + auth.toStringPrivate(), 
				password,
				this.Login()?.val()! 
			)
			
			this.Pass_key(null)!.val( pass_key )
		}

		@ $mol_mem_key
		auth_key_decrypt( password: string ) {

			const pass_key = this.Pass_key()?.val()!
			if( !pass_key ) return null

			const auth_key = $mol_wire_sync( $shm_hitalama_profile_key ).import( pass_key!, password )
			if( !auth_key ) return null

			return auth_key

		}

		@ $mol_action
		enter( password: string ) {
			const key = this.auth_key_decrypt( password )
			if( !key ) return false

			this.$.$giper_baza_auth.current( this.$.$giper_baza_auth.from( key ) )

			const home = this.$.$giper_baza_glob!.home().cast( $shm_hitalama_profile_home )
			home.Hitalama_profile(null)!.remote( this )
			return true
		}
		
		jsons() {
			return this.Jsons(null)?.ensure( this.land() )!
		}

		store( key: string, data?: any ) {
			const store = this.jsons().key( key, 'auto' )!.ensure( this.land() )!
			if( data === undefined ) return store.val()
			return store.val( data ) ?? null
		}

		store_patch( key: string, data_patch: any ) {
			return this.store( key, { ... ( this.store( key ) ?? {} ), ... data_patch } )
		}

		used_tags( next?: string[] ) {
			return (this.Used_tags(next)?.items( next ) ?? []) as string[]
		}

		bottom_quick_access_ordered( next?: string[] ) {
			return (this.Bottom_quick_access_ordered(next)?.items( next ) ?? []) as string[]
		}
		bottom_quick_access_new_add( id: string ) {
			const cur = this.bottom_quick_access_items()
			if( cur.find( it => it.id == id ) ) return
			const next = [ ...cur, { id, fullscreen: true } ]
			this.bottom_quick_access_items( next )
			this.bottom_quick_access_ordered([...this.bottom_quick_access_ordered(),id])
		}
		bottom_quick_access_ordered_remove( id: string ) {
			this.bottom_quick_access_item_remove( id )
			this.bottom_quick_access_ordered(this.bottom_quick_access_ordered().filter( i => i != id ))
		}

		bottom_quick_access_items( next?: Bottom_quick_access_item[] ) {
			return (this.Bottom_quick_access_items(next)?.val( next ) ?? []) as Bottom_quick_access_item[]
		}
		bottom_quick_access_item_push( id: string ) {
			const cur = this.bottom_quick_access_items()
			if( cur.find( it => it.id == id ) ) return
			const next = [ ...cur, { id, fullscreen: true } ]
			this.bottom_quick_access_items( next )
		}
		bottom_quick_access_item_remove( id: string ) {
			this.bottom_quick_access_items( [
				...(this.bottom_quick_access_items()??[]).filter( it => it.id != id )
			] )
		}

		@ $mol_action
		used_tags_add( tag: string ) {
			this.used_tags( [ tag, ...this.used_tags() ] )
		}

		@ $mol_mem
		agent_chat_room() {
			return this.Agent_chat_room(null)?.ensure( [[ null, $giper_baza_rank_deny ]] )!
		}

		@ $mol_mem
		agent_chat_options() {
			return this.Agent_chat_options(null)?.ensure( [[ null, $giper_baza_rank_deny ]] )!
		}

		@ $mol_mem
		secrets( next?: any ) {
			return this.Secrets(next)?.ensure( [[ null, $giper_baza_rank_deny ]] )?.val( next ) ?? {}
		}

		@ $mol_mem_key
		secret_val( key: string ){
			return (this.secrets() as any)[key] ?? ''
		}

		@ $mol_action
		add_map( title: string, access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			const map = $shm_hitalama_map.make_new( title, access_level )
			this.Maps_list(null)?.add( map.link() )
			return map
		}

		@ $mol_action
		template_map_make(
			title: string,
			widget_type: $shm_hitalama_map_widget_def_type_name,
			templates: readonly { title: string, code: string }[],
		) {
			return $shm_hitalama_map_templates.make_map( title, widget_type, templates )
		}

		templates_js() {
			let map = this.Templates_js(null)?.remote()
			if( this.template_map_filled( map ) ) return map

			map = $shm_hitalama_map_templates.import_js()
			this.Templates_js(null)?.remote( map )
			return map
		}

		templates_tsx() {
			let map = this.Templates_tsx(null)?.remote()
			if( this.template_map_filled( map ) ) return map

			map = $shm_hitalama_map_templates.import_tsx()
			this.Templates_tsx(null)?.remote( map )
			return map
		}

		templates_sql() {
			let map = this.Templates_sql(null)?.remote()
			if( this.template_map_filled( map ) ) return map

			map = $shm_hitalama_map_templates.import_sql()
			this.Templates_sql(null)?.remote( map )
			return map
		}

		template_map_filled( map: $shm_hitalama_map | null | undefined ) {
			const first = map?.Widgets_list(null)?.remote_list()[0]
			if( !first ) return false
			return Boolean( first.text() ) && first.right_edge_x() > 0 && first.bottom_edge_y() > 0
		}

		templates_commands() {
			let map = this.Templates_commands(null)?.remote()
			if( map ) {
				const actual = $shm_hitalama_map_templates.commands_actual( map )
				if( actual !== map ) this.Templates_commands(null)?.remote( actual )
				return actual
			}

			map = $shm_hitalama_map_templates.import_commands()
			this.Templates_commands(null)?.remote( map )
			return map
		}

		@ $mol_action
		selfhosted_defaults_ensure() {
			this.templates_js()
			this.templates_tsx()
			this.templates_sql()
			this.templates_commands()
			this.overlayed_map()
		}

		@ $mol_mem
		overlayed_map() {
			let map = this.Overlayed_map(null)?.remote()
			if( map && typeof map.deserialize === 'function' ) return $shm_hitalama_map_templates.overlayed_update( map )

			map = $shm_hitalama_map_templates.import_overlayed()
			this.Overlayed_map(null)?.remote( map )
			return map
		}

		overlayed_map_enabled( next?: boolean ) {
			return this.Overlayed_map_enabled(next)?.val( next ) ?? false
		}

		Maps_list(auto?: null) {
			const cache_key = `${ this.link().str }.Maps`
			const cached = $shm_hitalama_profile.maps_list_repair_cache.get( cache_key )
			if( cached && typeof cached.remote_list === 'function' ) return cached

			const slot = this.Maps()
			const list = slot?.remote()
			if( list && typeof ( list as any ).remote_list === 'function' ) {
				$shm_hitalama_profile.maps_list_repair_cache.set( cache_key, list )
				return list
			}

			const area = this.land().area_make()
			const fresh = $giper_baza_glob.Pawn( area.link(), $giper_baza_list_link.to( ()=> $shm_hitalama_map ) )
			this.Maps(null)?.remote( fresh )
			$shm_hitalama_profile.maps_list_repair_cache.set( cache_key, fresh )
			return fresh
		}

		Maps_removed_list(auto?: null) {
			const cache_key = `${ this.link().str }.Maps_removed`
			const cached = $shm_hitalama_profile.maps_list_repair_cache.get( cache_key )
			if( cached && typeof cached.remote_list === 'function' ) return cached

			const slot = this.Maps_removed()
			const list = slot?.remote()
			if( list && typeof ( list as any ).remote_list === 'function' ) {
				$shm_hitalama_profile.maps_list_repair_cache.set( cache_key, list )
				return list
			}

			const area = this.land().area_make()
			const fresh = $giper_baza_glob.Pawn( area.link(), $giper_baza_list_link.to( ()=> $shm_hitalama_map ) )
			this.Maps_removed(null)?.remote( fresh )
			$shm_hitalama_profile.maps_list_repair_cache.set( cache_key, fresh )
			return fresh
		}

		version( next?: number ) {
			return this.Version( next )?.val( next ) ?? 0
		}

		@ $mol_action
		cut_map( ref: $giper_baza_link ) {
			this.Maps_removed_list(null)?.add( ref )
			this.Maps_list(null)?.cut( ref )
			this.cut_template_map( ref )
		}

		@ $mol_action
		cut_template_map( ref: $giper_baza_link ) {
			const template_slots = [
				this.Templates_js(null),
				this.Templates_tsx(null),
				this.Templates_sql(null),
				this.Templates_commands(null),
				this.Overlayed_map(null),
			]

			for( const slot of template_slots ) {
				if( !slot ) continue
				if( slot.remote()?.link().toString() !== ref.toString() ) continue
				slot.remote( null )
			}
		}
		
	}
	
	/** @deprecated Use profile home/key auth instead. */
	export class $shm_hitalama_profile_dict extends $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_profile ) ) {
		
	}

}
